export const companySources = ["WORKER","EUROFISCALIS","SUPERADMIN"];